export const config = {
	baseURL: import.meta.env.VITE_API_URL || 'https://silver-glass-backend.bis-apps.com/',
	tokenKEY: 'token',
	phoneKEY: 'phone',
	backendTokenKEY: 'Authorization',
}
